var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellexxLogoTextOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 939 240",
    width: 939,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Selex Logo EN_Aug_2025") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #02aa9d } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m116 90.8q-0.3-8.8-6.1-14.8-5.8-5.9-18.7-5.9-13.4 0-19 6.2-5.7 6.3-5.7 14.2 0 8.6 7.3 12.1 7.4 3.5 18.4 5.8 10.9 2.3 23.8 4.7 12.8 2.5 23.8 8.6 11 6.1 18.3 17.5 7.3 11.5 7.3 31.3 0 15-5.3 26.9-5.4 11.9-15.3 20.3-9.9 8.4-23.8 13-13.9 4.5-30.7 4.5-16.8 0-30.4-4.4-13.5-4.4-23.5-12.5-9.9-8.1-15.4-19.7-5.5-11.6-5.8-26.3h48.3q0 9.5 6.1 15 6.1 5.5 20.7 5.5 14.7 0 20.8-5.5 6.1-5.5 6.1-15 0-6.4-4.3-9.9-4.3-3.5-11.1-5.5-6.9-1.9-15.7-3.5-8.9-1.5-18.1-3.6-9.1-2.2-18-5.8-8.8-3.7-15.7-10.1-6.9-6.4-11.1-16.5-4.3-10.1-4.3-25 0-14.1 5.2-26 5.2-11.9 14.5-20.6 9.3-8.7 22.6-13.4 13.2-4.8 29.4-4.8 15.6 0 28.6 4.6 12.9 4.6 22.4 12.8 9.5 8.3 14.8 20 5.4 11.8 6 25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m231.7 168.1v0.6q3 12.5 11.9 18.8 8.8 6.2 21.6 6.2 9.8 0 17.1-2.4 7.4-2.5 11.6-8.6h47.4q-7.4 23.5-27.5 37.7-20.2 14.2-48.6 14.2-18 0-32.8-5.9-14.8-6-25.6-16.5-10.9-10.5-16.8-25.2-6-14.6-6-31.7 0-17.1 6-31.8 5.9-14.6 16.8-25.2 10.8-10.5 25.6-16.5 14.8-5.9 32.8-5.9 17.8 0 32.6 5.9 14.8 6 25.5 16.5 10.6 10.6 16.4 25.2 5.8 14.7 5.8 31.8v12.8zm33.6-51.3q-11.9 0-20.4 5.5-8.6 5.5-12.2 16.2v0.6h65.9v-0.6q-4-10.7-12.7-16.2-8.7-5.5-20.6-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m374.2 230.7v-216.8h45.8v216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m459.7 230.7v-216.8h45.8v216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m581.8 168.1v0.6q3.1 12.5 11.9 18.8 8.9 6.2 21.7 6.2 9.8 0 17.1-2.4 7.3-2.5 11.6-8.6h47.3q-7.3 23.5-27.5 37.7-20.1 14.2-48.5 14.2-18 0-32.8-5.9-14.8-6-25.7-16.5-10.8-10.5-16.7-25.2-6-14.6-6-31.7 0-17.1 6-31.8 5.9-14.6 16.7-25.2 10.9-10.5 25.7-16.5 14.8-5.9 32.8-5.9 17.7 0 32.5 5.9 14.8 6 25.5 16.5 10.7 10.6 16.5 25.2 5.8 14.7 5.8 31.8v12.8zm33.6-51.3q-11.9 0-20.5 5.5-8.5 5.5-12.2 16.2v0.6h66v-0.6q-4-10.7-12.7-16.2-8.7-5.5-20.6-5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m811.8 86.6l-17.8 28 24.9 29.1 39.5-57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m810.2 156.3l-52-69.7h-46.6l48.2 69.7-51.6 74.5h47.5l29.5-46.2 29.4 46.2h47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m920.2 86.6h-46.7l-43.7 69.8 46.9 74.2h46.9l-51.3-74.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellexxLogoTextOnly);
export default __webpack_public_path__ + "static/media/sellexx_logo_text_only.e0cbab00fda6a9588326a59806561f1d.svg";
export { ForwardRef as ReactComponent };